export class AppUrlPath {
  public basePath: string;
  public tenantHomePath: string;
  public documentsPath: string;
  public agendaItemsPath: string;
  public agendaModulesPath: string;
  public agendaPath: string;
  public meetingsPath: string;
  public teamsPath: string;
  public usersPath: string;
  public settingsPath: string;
  public letterheadsPath: string;
  public agendaTemplatesPath: string;
  public integrationsPath: string;

  constructor(tenantId: string) {
    this.basePath = "/app";
    this.tenantHomePath = `${this.basePath}/tenant/${tenantId}`;
    this.documentsPath = `${this.tenantHomePath}/documents`;
    this.agendaItemsPath = `${this.tenantHomePath}/agendaItems`;
    this.agendaPath = `${this.tenantHomePath}/agendas`;
    this.meetingsPath = `${this.tenantHomePath}/meetings`;
    this.teamsPath = `${this.tenantHomePath}/teams`;
    this.usersPath = `${this.tenantHomePath}/users`;
    this.settingsPath = `${this.tenantHomePath}/settings`;
    this.letterheadsPath = `${this.settingsPath}/letterheads`;
    this.agendaModulesPath = `${this.tenantHomePath}/agendaModules`;
    this.agendaTemplatesPath = `${this.settingsPath}/agendaTemplates`;
    this.integrationsPath = `${this.settingsPath}/integrations`;
  }

  public getDocumentPath(documentId: string) {
    return `${this.documentsPath}/${documentId}`;
  }

  public getDocumentSignPath(documentId: string) {
    return `${this.documentsPath}/${documentId}/sign`;
  }

  public getAgendaItemPath(agendaItemId: string) {
    return `${this.agendaItemsPath}/${agendaItemId}`;
  }

  public getAgendaModulePath(agendaModuleId: string) {
    return `${this.agendaModulesPath}/${agendaModuleId}`;
  }

  public getAgendaPath(agendaId: string) {
    return `${this.agendaPath}/${agendaId}`;
  }

  public getMeetingPath(meetingId: string) {
    return `${this.meetingsPath}/${meetingId}`;
  }

  public getMeetingAgendaPath(meetingId: string, agendaId: string) {
    return `${this.meetingsPath}/${meetingId}/agenda/${agendaId}`;
  }

  public getMeetingAgendaItemPath(
    meetingId: string,
    agendaId: string,
    itemId: string
  ) {
    return `${this.meetingsPath}/${meetingId}/agenda/${agendaId}/item/${itemId}`;
  }

  public getMeetingRunPath(
    meetingId: string,
    meetingItem?: string,
    itemSection?: string
  ) {
    let path = `${this.meetingsPath}/${meetingId}/run`;
    if (meetingItem) {
      path += `/${meetingItem}`;
      if (itemSection) {
        path += `/${itemSection}`;
      }
    }
    return path;
  }

  public getTeamPath(teamId: string) {
    return `${this.teamsPath}/${teamId}`;
  }

  public getUserPath(userId: string) {
    return `${this.usersPath}/${userId}`;
  }

  public getAgendaTemplatePath(templateId: string) {
    return `${this.agendaTemplatesPath}/${templateId}`;
  }

  public getLetterHeadPath(letterHeadId: string) {
    return `${this.letterheadsPath}/${letterHeadId}`;
  }

  public getIntegrationPath(integration: string, subPath?: string) {
    return `${this.integrationsPath}/${integration}${subPath ? "/" + subPath : ""}`;
  }
}
